export const prefix = "control-center-use-local-storage-";

/**
 * Interface defining the structure of a local storage key entry
 */
export interface LocalStorageKeyEntry {
  /** The storage value used when accessing localStorage */
  value: string;
  /** Description of what this key is used for */
  description: string;
  /** Optional maximum length for array-based storage items */
  maxLength?: number;
}
